module.exports = __webpack_public_path__ + "img/guestPass.77744319.png";